import { FC } from 'react';
import { Container } from 'react-bootstrap';
import BaseTemplate from '../BaseTemplate';
import LandscapeEditProjectsAddProjectTemplate from '../../../templates/LandscapeEditProjectsAddProjectTemplate';
import LandscapeProjectsEditProjectsImpactTemplate from '../../../templates/LandscapeProjectsEditProjectsImpactTemplate';
import styles from './LandscapeProjectsAddProjectsImpactTargetTemplate.module.css';
import cn from 'classnames';
import { LandscapeProjectsImpactTargetOrganism } from '../../organisms';
import { ProjectTargetResponseDto } from '../../../store/landscapeAPI/project/dto/response/project-target-response.dto';

interface LandscapeProjectsAddProjectsImpactTargetTemplateProps {
  listItems: ProjectTargetResponseDto[];
  setListItems: (
    items: ProjectTargetResponseDto[],
    from: number,
    to: number
  ) => void;
  handleDelete: (id: string) => void;
  handleSubmit: () => void;
  handleOnChange: (projectTarget: ProjectTargetResponseDto) => void;
  handleAddTarget: () => void;
}

const LandscapeProjectsAddProjectsImpactTargetTemplate: FC<
  LandscapeProjectsAddProjectsImpactTargetTemplateProps
> = ({
  listItems,
  setListItems,
  handleDelete,
  handleSubmit,
  handleOnChange,
  handleAddTarget,
}) => {
  return (
    <>
      <BaseTemplate>
        <Container>
          <LandscapeEditProjectsAddProjectTemplate>
            <LandscapeProjectsEditProjectsImpactTemplate>
              <div className={cn(styles.landscapeWrapper)}>
                <LandscapeProjectsImpactTargetOrganism
                  listItems={listItems}
                  setListItems={setListItems}
                  handleDelete={handleDelete}
                  handleSubmit={handleSubmit}
                  handleOnChange={handleOnChange}
                  handleAddTarget={handleAddTarget}
                />
              </div>
            </LandscapeProjectsEditProjectsImpactTemplate>
          </LandscapeEditProjectsAddProjectTemplate>
        </Container>
      </BaseTemplate>
    </>
  );
};

export default LandscapeProjectsAddProjectsImpactTargetTemplate;
